import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import FunnelProgressBar, { formatFunnelPercent } from './FunnelProgressBar';
import { normalizeMetric } from '../utils/metricFormatters';

const journeyStages = [
  {
    name: 'Signups',
    key: 'signups',
    fallback: { count: 0, percentage: 0 },
  },
  {
    name: 'Completed Profile',
    key: 'completedProfile',
    fallback: { count: 0, percentage: 0 },
  },
  {
    name: 'Saw Intro',
    key: 'sawIntro',
    fallback: { count: 0, percentage: 0 },
  },
  {
    name: 'Opened Chat',
    key: 'openedChat',
    fallback: { count: 0, percentage: 0 },
  },
  {
    name: 'Sent Message',
    key: 'sentMessage',
    fallback: { count: 0, percentage: 0 },
  },
  {
    name: 'Got Reply',
    key: 'gotReply',
    fallback: { count: 0, percentage: 0 },
  },
  {
    name: 'Reached 4+ Messages',
    key: 'reached4Messages',
    fallback: { count: 0, percentage: 0 },
  },
];

const ConnectionJourney = ({ metrics }) => {
  const apiJourney = metrics?.connectionJourney || {};
  const journeyData = journeyStages.map((stage) => {
    const raw = apiJourney[stage.key];
    const normalized = normalizeMetric(raw);
    const stageData = normalized
      ? {
          count: normalized.count,
          percentage: normalized.percentage,
        }
      : {
          count: stage.fallback.count,
          percentage: stage.fallback.percentage,
        };
    return {
      name: `${stage.name} (${stageData.count})`,
      percentage: Number(stageData.percentage) || 0,
    };
  });

  return (
    <Box sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'medium' }}>
          Connection Journey
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          mt: 3,
        }}
      >
        {journeyData.map((response, index) => (
          <Grid container key={index} alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={8}>
              <FunnelProgressBar value={response.percentage} formatLabel={formatFunnelPercent} />
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ fontSize: 14 }}>{response.name}</Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Box>
  );
};

export default ConnectionJourney;
